// extracted by mini-css-extract-plugin
module.exports = {"container":"_28iX8","header":"_2FoIB","closeIcon":"_2aU_k"};